export default "__VITE_ASSET__BLfB7W_7__"